import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useTexture } from '@react-three/drei';
import { SRGBColorSpace } from 'three';
import { useCelestial } from './CelestialProvider.jsx';

export function Moon({ position = [0.82, 0.24, -0.15], scale = 1, radius = 0.26, drift = true }) {
  const ref = useRef();
  const { perfTier } = useCelestial();
  const texture = useTexture('/assets/textures/moon_2k.jpg', (t) => {
    t.colorSpace = SRGBColorSpace;
    t.anisotropy = 4;
  });

  useFrame((state) => {
    if (!ref.current) return;
    if (drift) {
      ref.current.position.x = position[0] + Math.sin(state.clock.elapsedTime * 0.22) * 0.06;
      ref.current.position.y = position[1] + Math.cos(state.clock.elapsedTime * 0.2) * 0.035;
    }
    ref.current.rotation.y = state.clock.elapsedTime * 0.16;
  });

  return (
    <mesh ref={ref} position={position} scale={scale}>
      <sphereGeometry args={[radius, perfTier.tier >= 2 ? 48 : 28, perfTier.tier >= 2 ? 24 : 16]} />
      <meshStandardMaterial map={texture} roughness={1} metalness={0} />
    </mesh>
  );
}
